import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type MemberAffiliate } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberAffiliate.AppState>(defaultState, previewState);
